import {Component, Input, OnChanges, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {take} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import { RestUrlsConfig, GenericConfig  } from '@signature-it/ngx-generic/config';
import { AuthService } from '@signature-it/ngx-generic/services';
import { IUser } from '@signature-it/ngx-generic/interfaces';
import { SignedUserDTO } from '@signature-it/ngx-generic/models';
import {SharedDataService, GroupApiService} from '@signature-it/ngx-catalogue/services';
import {Group, ProductFieldDTO} from '@signature-it/ngx-catalogue/models';
import {ProductFieldDisplayType} from '@signature-it/ngx-catalogue/enums';
declare let _: any;

@Component({
    selector: 'filters',
    templateUrl: './filters.component.html',
    styleUrls: ['./filters.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FiltersComponent implements OnChanges {
    filtersList: any;
    filterArray: Object;
    filterConvert: any;
    filters = {};
    multiSelect: Array<any>;
    entranceCount: number;
    enter: string;
    filterIndexData: any;
    query = [];
    dependenceFilters = {};
    dependedFilters = [];
    imagesBaseUrl = '';
    user: IUser;
    allowedFilterValuesForPivot = GenericConfig.allowedFilterValuesForPivot || null;
    public scrollbarOptions = { axis: 'y', theme: 'dark-thick'};
    private destroy$: Subject<void> = new Subject<void>();
    public FieldDisplayType = ProductFieldDisplayType;
    group: Group;
    openCatalogueFiltersCount = GenericConfig.openCatalogueFiltersCount || 3;

    @Input() facets;
    @Input() currentGroupId;
    @Input() checkedFacets;
    @Input() mode = 'dropdown';
    @Input() fields;
    @Input() displayType: keyof typeof ProductFieldDisplayType;
    userLinks: {
        [key: string] : ProductFieldDTO
    };
    userLinksFields: Array<ProductFieldDTO>;

    constructor(
        public sharedData: SharedDataService,
        public groupApiSvc: GroupApiService,
        protected restUrlsConf: RestUrlsConfig,
        protected authService: AuthService,
        protected cookie: CookieService) {
        this.filtersList = [];
        this.filterArray = {};
        this.filterConvert = [];
        this.entranceCount = 0;
        this.multiSelect = [];
        this.enter = '';
        this.filterIndexData = {};
        this.imagesBaseUrl = `${this.restUrlsConf.beURL}/images/Fittings/${GenericConfig.systemName}/field_images/`;
    }

    async getGroupId(id) {
        if (id == 1) return 1;
        this.group = await this.groupApiSvc.getCurrentGroup(id).pipe(take(1)).toPromise();
        return this.group.isleaf ? parseInt(id) : 1;
    }

    async getUserLinks(groupId) {
        return this.fields ? await this.groupApiSvc.getUserLinksByFields(1, this.fields).toPromise() : await this.groupApiSvc.getUserLinksByGroup(groupId, this.group?.taxonomyVar, this.group?.entityVar).pipe(take(1)).toPromise();
    }

    async ngOnChanges(changes: SimpleChanges) {
        const self = this;
        if (changes.currentGroupId && changes.currentGroupId.currentValue && changes.currentGroupId.previousValue != changes.currentGroupId.currentValue) {
            self.userLinks = null;
            self.filtersList = [];
            self.filterConvert = [];
            let groupId = await this.getGroupId(self.currentGroupId);
            self.userLinksFields = await this.getUserLinks(groupId);
            self.userLinksFields.forEach((filter: ProductFieldDTO) => {
                if (filter.id != -1) {
                    if (!self.userLinks) {
                        self.userLinks = {};
                    }
                    filter.displayType = this.displayType || filter.displayType;
                    self.userLinks[filter.solr_field] = filter;
                }
            });
        }

        if (changes.checkedFacets && changes.checkedFacets.currentValue) {
            this.filters = this.checkedFacets;
        }

        if (changes.facets && changes.facets.currentValue) {
            this.getCurrentUser().subscribe(user => {
                let data = changes.facets.currentValue;
                let navigationObject = {};
                let facet_fields = data['facet_fields'];
                for (let key in facet_fields) {
                    if (key !== 'count' && key !== 'group_id_is' && key !== 'FamilyName_ss' && facet_fields[key] && facet_fields[key].length > 1) {
                        const allowedFilters = this.getAllowedFiltersByVarietyKey(key, user);
                        if (!allowedFilters.length) {
                            navigationObject[key] = facet_fields[key];
                        } else {
                            navigationObject[key] = this.filterFacetsByVarietyKey(facet_fields[key], allowedFilters);
                        }
                        if(GenericConfig.omitLettersForFacetSort && GenericConfig.omitLettersForFacetSort.includes(key)) {
							navigationObject[key] = this.handleOmitLettersAndSort(navigationObject[key]);
                        }
                        let productField = this.userLinksFields.find(field => field['solr_field'] === key);
                        if(productField?.['sort_option']=="name"){
                            navigationObject[key] = this.handleSortByName(navigationObject[key]);
                        }
                        if(productField?.['sort_option']=="uom" && productField['unit_of_measure_mapping']){
                            navigationObject[key] = this.handleCommonUnitAndSort(navigationObject[key], productField['unit_of_measure_mapping'])
                        }
                    }
                }
                const self = this;
                _.each(data['facet_pivot'], (
                    (val, key) => {
                        let dependFilter = key.split(',')[0];
                        this.dependedFilters.push(key.split(',')[1]);
                        if (navigationObject[dependFilter]) {
                            if (!self.dependenceFilters[dependFilter]) {
                                self.dependenceFilters[dependFilter] = [];
                            }

                            _.each(val, (
                                (value) => {
                                    var isAllowedFilter;
                                    if (this.allowedFilterValuesForPivot) {
                                        isAllowedFilter = false;
                                        isAllowedFilter = _.find(this.allowedFilterValuesForPivot, (val: any) =>
                                            val === value['value']
                                        );
                                    }
                                    if (!this.allowedFilterValuesForPivot || this.allowedFilterValuesForPivot && isAllowedFilter) {
                                        self.dependenceFilters[dependFilter][value['value']] = value['pivot'];
                                    }
                                }));
                        }
                    }), navigationObject);
                this.filtersList = navigationObject;
                this.filterConvert = Object.keys(this.filtersList);
            }, error => console.log(error)).unsubscribe();
        }
    }

    public trackItem(index: number, item) {
        return `${item[0]}`;
    }

    clickedFilter(filterName, value, isPseudo = false) {
        let obj = {};
        if (this.userLinks[filterName] && this.userLinks[filterName].displayType === this.FieldDisplayType.RADIO_BUTTON) {
            obj[filterName] = value;
        } else if (this.isChecked(filterName, value) == true || isPseudo && this.isChecked(filterName, value) == 'checked') {
            if (_.isString(this.filters[filterName])) {
                delete this.filters[filterName];
            } else {
                let index =  this.filters[filterName].indexOf(value);
                this.filters[filterName].splice(index, 1);
                if (this.filters[filterName].length == 0) {
                    delete this.filters[filterName];
                }
            }
        } else {
            if (this.filters[filterName] && _.isString(this.filters[filterName])) {
                obj[filterName] = [this.filters[filterName]];
            } else if (this.filters[filterName] && _.isArray(this.filters[filterName])) {
                obj[filterName] = this.filters[filterName];
            } else {
                obj[filterName] = [];
            }
            obj[filterName].push(value);
        }
        this.filters = _.assign({}, this.filters, obj);
        this.sharedData.clickedFilter.next({fields: this.filters});
    }

    isHiddenFilter(filterName) {
        if (GenericConfig.hiddenFilters && GenericConfig.hiddenFilters.includes(filterName)) {
            return true;
        }
        if (GenericConfig.dependedFilters && GenericConfig.dependedFilters[filterName]) {
            return !GenericConfig.dependedFilters[filterName].every(key => this.filters.hasOwnProperty(key));
        }
        return this.dependedFilters.includes(filterName);
    }

    isChecked(filterName, value, isPseudo = false) {
        let isChecked;
        if (_.isString(this.filters[filterName])) {
            isChecked = Boolean(this.filters[filterName] == value);
        } else {
            isChecked = Boolean(this.filters[filterName] && this.filters[filterName].includes(value));
        }
        return isPseudo ? isChecked ? 'checked' : 'unchecked' : isChecked;
    }

    filterCount(filterName) {
        if (_.isString(this.filters[filterName])) {
            return 1;
        }
        return this.filters[filterName] && this.filters[filterName].length;
    }

    showClear(filterName) {
        return this.filters[filterName];
    }

    clear(event, filterName) {
        event.stopPropagation();
        delete this.filters[filterName];
        this.sharedData.clickedFilter.next({fields: this.filters});
    }

    getCurrentUser() {
        return new Observable<IUser>(observer => {
            if (this.user) {
                observer.next(this.user);
            } else {
                this.authService.usersData$.pipe(take(1)).subscribe((user: IUser) => {
                    if (user) {
                        this.user = user;
                        observer.next(this.user);
                    } else {
                        observer.error('Error getting user in filters component');
                    }
                });
            }
        });
    }

    getAllowedFiltersByVarietyKey(filterKey, user: IUser) {
        let varietyKey = '';
        if(user instanceof SignedUserDTO) {
            varietyKey = user.variety_solr_key;
        }
        let varietySessionKey = this.cookie.get('varietySessionValue') ? this.cookie.get('varietySessionValue'): false;

        if(!varietySessionKey){
            if (!(user instanceof SignedUserDTO)) {
                return [];
            }
            if (this.cookie.get('varietyValue') && this.cookie.get('varietyValue') === 'allProducts') {
                return [];
            }

            if (!varietyKey) {
                return [];
            }
        } else {
            if(varietyKey){
                varietyKey += "&";
            }
            varietyKey += varietySessionKey;
        }
        if (varietyKey.indexOf(filterKey) === -1) {
            return [];
        }
        const r = new RegExp(`${filterKey}:\\((.*)\\)`);
        const match = varietyKey.match(r);
        if (!varietyKey.match(r)) {
            return [];
        } else {
            // return texts array without wrapped ""
            return varietyKey.match(r)[1].split('OR').map(f => {
                f = f.trim();
                return f.substring(1, f.length - 1)
            });
        }
    }

    filterFacetsByVarietyKey(facets, allowedFilters) {
        let _facets = [];
        allowedFilters.forEach(filter => {
            _facets =  _facets.concat(facets.filter((elem) => {
                return elem[0] === filter;
            }));
        });
        return _facets;
    }

	handleOmitLettersAndSort(facet){
		 return facet.sort((a, b) => {
            let x = this.toDecimal(a[0]);
		 	let y = this.toDecimal(b[0]);
		 	return (x < y) ? -1 : (x > y) ? 1 : 0;
		 });
	}

    handleSortByName(facet){
        return facet.sort((a, b) => {
            return (a[0] < b[0]) ? -1 : (a[0] > b[0]) ? 1 : 0;
        });
    }

    handleCommonUnitAndSort(facet, commonUnit){
		 return facet.sort((a, b) => {
            let x = this.toDecimal(a[0]);
            x = this.toCommonUnites(a[0], x, commonUnit);
		 	let y = this.toDecimal(b[0]);
            y = this.toCommonUnites(b[0], y, commonUnit);
		 	return (x < y) ? -1 : (x > y) ? 1 : 0;
		 });
	}
    toCommonUnites(facetValue, facetValueDecimal, commonUnit){
        const facetUnit = facetValue.replace(/&lrm;(?=.*[m])(?=.*[l])(?=.*[r])/g, '').replace(/[0-9\/\-\/.\/‎]/g, '').trim();
        const unit = commonUnit.filter(item => item['unitName'].split(",").includes(facetUnit))?.[0];
        if (!unit) {
            return facetValueDecimal;
        }
        switch (unit['operator']) {
            case "*":
                return facetValueDecimal * unit['num'];
            case "/":
                return facetValueDecimal / unit['num'];
            case "%":
                return facetValueDecimal % unit['num'];
            default:
                return;
        }
    }

	toDecimal(_x){
        _x = _x.replace("-"," ").replace(/(?!(\d)|\/|\s|\.)./g,"").trim();
		if(!_x) return 0;
		const parts = _x.split(/\s/g);
		if(!parts[1] && parts[0].indexOf("/") == -1) {
			return parseFloat(_x);
		}
		if(parts[0].indexOf("/") != -1) {
			let decParts = parts[0].split("/");
			return (parseInt(decParts[0], 10) / parseInt(decParts[1], 10));
		}
		let decParts = parts[1].split("/");
		return parseInt(parts[0], 10) +
			(parseInt(decParts[0], 10) / parseInt(decParts[1], 10));
	}
}
